import { defineMessages } from 'react-intl'

const messages = {
  title: {
    id: 'app.components.organization-picker.title',
    defaultMessage: 'Select your organization',
  },
  label: {
    id: 'app.components.organization-picker.label',
    defaultMessage: 'Organization',
  },
  notFound: {
    id: 'app.components.organization-picker.not-found',
    defaultMessage: 'Organization not found',
  },
  continue: {
    id: 'app.components.organization-picker.continue',
    defaultMessage: 'Continue',
  },
}

export default defineMessages(messages)
